let fieldConfig = {
    version: 1.5,
    profileType: '44',
    queryForm: [
        {
            label: '开票点',
            selected: true,
            default: false,
            name: 'ukeyId',
            type: 'ukey',
        },
        {
            label: '查询类型',
            selected: true,
            default: false,
            name: 'collection',
            dict: 'red_confirm_collection',
            type: 'dict',
        },
        {
            label: '对方纳税人识别号',
            selected: true,
            default: false,
            name: 'otherSideTaxNo',
            type: 'fply',
        },
        {
            label: '对方纳税人名称',
            selected: true,
            default: false,
            name: 'otherSideName',
            type: 'fply',
        },
        {
            label: '全电发票号码',
            selected: true,
            default: false,
            name: 'electricInvoiceNum',
        },
        {
            label: '开票日期',
            selected: true,
            default: false,
            name: 'invoiceDate',
            type: 'date',
        },
        {
            label: '发票代码',
            selected: false,
            default: false,
            name: 'invoiceCode',
        },
        {
            label: '发票号码',
            selected: false,
            default: false,
            name: 'invoiceNumber',
        },
        {
            label: ' 发票来源',
            selected: false,
            default: false,
            isHide: false,
            name: 'invoiceSource',
            dict: 'red_confirm_invoice_source',
            type: 'fply',
        },
        {
            label: ' 发票种类',
            selected: true,
            default: true,
            name: 'invoiceType',
            dict: 'invoice_type',
            type: 'dict',
        },
        {
            label: ' 发票状态',
            selected: true,
            default: true,
            name: 'invoiceStatus',
            dict: 'status_type',
            type: 'dict',
        },
        {
            label: '购方名称/信用代码',
            selected: false,
            default: false,
            isHide: false,
            name: 'custNameCreditCode',
            type: 'gfxf',
        },
        {
            label: '销方名称/信用代码',
            selected: false,
            default: false,
            isHide: false,
            name: 'saleNameCreditCode',
            type: 'gfxf',
        },
    ],
    table: [
        {
            label: '发票种类',
            selected: true,
            default: false,
            name: 'invoiceType',
            dict: 'invoice_type',
            type: 'dict',
            sort: false,
        },
        {
            label: '全电发票号码',
            selected: true,
            default: false,
            name: 'electricInvoiceNum',
            sort: false,
        },
        {
            label: '发票代码',
            selected: true,
            default: false,
            name: 'invoiceCode',
            sort: false,
        },
        {
            label: '发票号码',
            selected: true,
            default: false,
            name: 'invoiceNumber',
            sort: false,
        },
        {
            label: '购方名称',
            selected: true,
            default: false,
            name: 'custName',
            sort: false,
            type: 'gf',
        },
        {
            label: '购方识别号',
            selected: true,
            default: false,
            name: 'custCreditCode',
            sort: false,
            type: 'gf',
        },
        {
            label: '销方名称',
            selected: false,
            default: false,
            name: 'saleName',
            sort: false,
            type: 'xf',
        },
        {
            label: '销方识别号',
            selected: false,
            default: false,
            name: 'saleCreditCode',
            sort: false,
            type: 'xf',
        },
        {
            label: '发票状态',
            selected: true,
            default: false,
            name: 'invoiceStatus',
            dict: 'invoice_status',
            type: 'dict',
            sort: false,
        },
        {
            label: '开票日期',
            selected: true,
            default: false,
            name: 'invoiceDate',
            sort: false,
        },
        {
            label: '金额',
            selected: true,
            default: false,
            name: 'totalAmt',
            sort: false,
        },
        {
            label: '税额',
            selected: true,
            default: false,
            name: 'totalTaxamt',
            sort: false,
        },
        {
            label: '价税合计',
            selected: true,
            default: false,
            name: 'adValoremTotal',
            sort: false,
        },
    /*    {
            label: '发票来源',
            selected: true,
            default: false,
            name: 'invoiceSource',
            dict: 'red_confirm_invoice_source',
            type: 'dict',
            sort: false,
        },*/
        {
            label: '发票来源',
            selected: true,
            default: false,
            name: 'invoiceSource',
            dict: 'invoice_source',
            type: 'dict',
            sort: false,
        },
    ],
}

export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/directive/selectTicket/fieldConfig.js